var themeConfig = {
  honeycombThemePrefix: 'hcr-theme-',
  honeycombThemes: ['default', 'dark', 'kamil']
};

export default themeConfig;
